import { z } from 'zod';

import { RingSerialRegex } from '../utils/validation';

const ZUORA_EMAIL_MAX_CHAR_LENGTH = 80;

// Our current JWT token size is 290-330 characters, but we want to allow for some buffer
export const authorizationHeaderSchema = z.string().regex(/^Bearer .{200,500}$/);

export type AuthorizationHeaderSchema = z.infer<typeof authorizationHeaderSchema>;

export const ouraAccountIdSchema = z.string().uuid();
export type OuraAccountId = z.infer<typeof ouraAccountIdSchema>;

export const ringSerialSchema = z.string().regex(RingSerialRegex);
export type RingSerial = z.infer<typeof ringSerialSchema>;

// Don't allow emails longer what Zuora allows
export const emailSchema = z.string().email().max(ZUORA_EMAIL_MAX_CHAR_LENGTH);

export const LOCALES = ['da', 'de', 'en', 'es', 'fi', 'fr', 'it', 'ja', 'nb', 'sv'] as const;
export const localeSchema = z.enum(LOCALES);
export type Locale = z.infer<typeof localeSchema>;

export const accountSource = z.enum(['legacy', 'moi']);
export type AccountSource = z.infer<typeof accountSource>;

export const userSchema = z.object({
  accountId: ouraAccountIdSchema,
  accountSource: accountSource.optional(),
});

export type User = z.infer<typeof userSchema>;
export type Context = Record<string, any>;
export type ErrorDetails = Record<string, any>;

export interface ResponseError {
  error?: ErrorDetails;
}

export const msUnitSchema = z.enum([
  '1m',
  '5m',
  '15m',
  '30m',
  '1h',
  '3h',
  '6h',
  '12h',
  '1d',
  '7d',
  '30d',
  '90d',
  '180d',
  '365d',
  '1w',
  '4w',
]);
export type MsUnit = z.infer<typeof msUnitSchema>;

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace Express {
    export interface Request {
      user?: User;
      accessToken?: string;
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-object-type
    export interface Response extends ResponseError {}
  }
}
